<ng-container *transloco="let t">
  <p-dialog
    [modal]="true"
    [dismissableMask]="true"
    styleClass="about-dialog"
    [visible]="layoutService.displayAboutDialog$ | async"
    (visibleChange)="close()"
  >
    <p-header><i class="mr-1 fad fa-circle-info"></i> {{ t('core.layout.footer.about.title') }}</p-header>

    <div class="notice">
      <div class="logo">
        <z-logo></z-logo>
      </div>
      <div class="version">
        {{ t('core.layout.footer.about.version') }} {{ version | uppercase }} - {{ language$ | async | uppercase }} -
        {{ environment | uppercase }}
      </div>
      <div class="copyright">&copy; {{ copyrightYear }} {{ companyName }}</div>
    </div>

    <p-divider></p-divider>

    <ng-container *ngFor="let license of licenses$ | async">
      <div>
        <div class="license-field">
          <div class="label">{{ t('core.layout.footer.about.package') }}:</div>
          <div class="value">{{ license.name }}</div>
        </div>

        <div class="license-field">
          <div class="label">{{ t('core.layout.footer.about.version') }}:</div>
          <div class="value">{{ license.version }}</div>
        </div>

        <div class="license-field">
          <div class="label">{{ t('core.layout.footer.about.license') }}:</div>
          <div class="value">{{ license.licenses }}</div>
        </div>

        <div class="license-field">
          <div class="text">{{ license.licenseText }}</div>
        </div>
      </div>

      <p-divider></p-divider>
    </ng-container>

    <p-footer>
      <p-button
        (click)="close()"
        icon="pi pi-check"
        label="{{ t('core.layout.footer.about.close') }}"
        styleClass="p-button-primary"
      ></p-button>
    </p-footer>
  </p-dialog>
</ng-container>
